// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".prompt-textarea--vByRX{font-size:12px;line-height:1.5}.char-count--c7xpH{font-size:11px}.session-note--viDXJ{font-size:12px}.session-note-icon--wZofm{font-size:14px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prompt-textarea": "prompt-textarea--vByRX",
	"char-count": "char-count--c7xpH",
	"session-note": "session-note--viDXJ",
	"session-note-icon": "session-note-icon--wZofm"
};
export default ___CSS_LOADER_EXPORT___;
